export default __webpack_public_path__ + "static/media/question.60516098.gif";